import axios from "axios";

export async function exportCsvReport(url, token, params = {}) {
    const response = await axios.get(url, {
        headers: {
            Authorization: "Bearer " + token,
            Accept: "text/csv"
        },
        params,
        responseType: "blob"
    });
    return { blob: response.data, headers: response.headers };
}

